<div class="container">
  <div class="row">
<!--    <mat-form-field class="col-md-4 col-sm-4" appearance="outline">-->
<!--      <mat-label>Select Centre</mat-label>-->
<!--      <mat-select [ngModel]="SelectedCentre"  (selectionChange)="setSelectedCentreCode($event)">-->
<!--        <mat-option *ngFor="let c of (centres$ | async)" [value]="c.centreCode">{{ c.centreName }}</mat-option>-->
<!--      </mat-select>-->
<!--    </mat-form-field>-->

    <app-searchable-select
      class="col-md-4"
      [(ngModel)]="SelectedCentre"
      [options]="centres$ | async"
      [displayWithFn]="displayCentre"
      [placeholder]="'Select Centre'"
      [label]="'Select Centre'"
      (selectionChange)="setSelectedCentreCode($event)">
    </app-searchable-select>



    <!--    <mat-form-field class="col-md-4 col-sm-4" appearance="outline">-->
<!--      <mat-label>Select Child</mat-label>-->
<!--      <mat-select (selectionChange)="setSelectedChild($event)" [disabled]="selectedCentreCode == ''">-->
<!--        <mat-option *ngFor="let c of (children$ | async)" [value]="c">{{ c.firstName }} {{ c.lastName }}</mat-option>-->
<!--      </mat-select>-->
<!--    </mat-form-field>-->

    <mat-form-field class="col-md-4 col-sm-4" appearance="outline">
      <mat-label>Select Child</mat-label>

      <mat-select
        (selectionChange)="setSelectedChild($event)"
        [disabled]="selectedCentreCode == ''">

        <!-- 🔍 Search box inside dropdown -->
        <div class="mat-select-search">

          <input
            matInput
            placeholder="Search child"
            [(ngModel)]="childSearchText"
            (keyup)="filterChildren()"
            autocomplete="off" />

        </div>

        <!-- 👶 Filtered children list -->
        <mat-option
          *ngFor="let c of filteredChildren"
          [value]="c">
          {{ c.firstName }} {{ c.lastName }}
        </mat-option>

      </mat-select>
    </mat-form-field>


    <button mat-mini-fab color="accent" (click)="search()" [disabled]="!selectedChild"><mat-icon>search</mat-icon></button>
    <button class="mx-2" mat-mini-fab color="accent" (click)="clearAll()"><mat-icon>clear</mat-icon></button>
  </div>

  <section>
    <div class="ngxTableHeader">
      <ul class="header-buttons-left ms-0 mb-0">
        <li class="dropdown">
          <h2>Treatment Duration Report</h2>

        </li>
        <li class="dropdown m-l-20">
          <label id="search-input"><i class="material-icons search-icon">search</i></label>
          <input placeholder="Search" type="text" class="browser-default search-field" (keyup)='applyFilter($event)'
                 aria-label="Search box" #input>
        </li>
      </ul>

    </div>
    <div class="average-stats">
      <div class="average-days">
        <p><strong>Average Days of Stay: {{ averageDuration | number:'1.0-2' }} days</strong></p>
      </div>
      <div class="average-followup-days">
        <p>  <strong>Average Follow-up Days: {{ averageFollowupDays | number:'1.0-2' }} days</strong></p>
      </div>
    </div>

    <div class="mat-elevation-z8">
      <mat-table [dataSource]="datasource" matSort>
        <!-- Add your columns here -->
        <ng-container matColumnDef="sr">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Sr </mat-header-cell>
          <mat-cell *matCellDef="let row; let i = index"> {{ i + 1 }} </mat-cell>
          <mat-footer-cell mat-footer-cell *matFooterCellDef> </mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="childName">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Child Name </mat-header-cell>
          <mat-cell *matCellDef="let row"> {{ row.childName }} </mat-cell>
          <mat-footer-cell *matFooterCellDef><strong>Total</strong></mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="centreName">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Centre </mat-header-cell>
          <mat-cell *matCellDef="let row"> {{ row.centreName }} </mat-cell>
          <mat-footer-cell *matFooterCellDef> </mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="dateOfAdmission">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Date Of Admission </mat-header-cell>
          <mat-cell *matCellDef="let row"> {{ row.admissionDate | date: 'dd/MM/yyyy' }} </mat-cell>
          <mat-footer-cell *matFooterCellDef> </mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="dateOfDischarge">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Date Of Discharge </mat-header-cell>
          <mat-cell *matCellDef="let row"> {{ row.dischargeDate | date: 'dd/MM/yyyy' }} </mat-cell>
          <mat-footer-cell *matFooterCellDef> </mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="duration">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Duration </mat-header-cell>
          <mat-cell *matCellDef="let row"> {{ row.treatmentDuration }} </mat-cell>
          <mat-footer-cell *matFooterCellDef> {{ calculateTotalDuration(datasource.data) }} </mat-footer-cell>
        </ng-container>
        <!-- Add other columns similarly -->
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        <mat-footer-row *matFooterRowDef="displayedColumns"></mat-footer-row>
      </mat-table>

      <mat-paginator [pageSizeOptions]="[25, 50, 100, 200, 250, 500, 1000]"></mat-paginator>
    </div>


  </section>
</div>
